import React, { useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { textmapping } from "../../helper";

export const CropperComponent = (props) => {
  const [cropData, setCropData] = useState("#");
  const [cropper, setCropper] = useState();

  const getCropData = (props) => {
    console.log(props)
    if (typeof cropper !== "undefined") {
      setCropData(cropper.getCroppedCanvas().toDataURL());
      props.getcroppedimage(cropper.getCroppedCanvas().toDataURL());
    }
  };

  return (
    <div>
      <div style={{ width: "100%" }}>
        <Cropper
          style={{ height: 400, width: "100%" }}
          zoomTo={0}
          initialAspectRatio={1}
          src={props.image}
          dragMode={"move"}
          // viewMode={1}
          background={false}
          cropBoxMovable={true}
          minContainerWidth={300}
          minContainerHeight={300}
          minCropBoxWidth={200}
          minCropBoxHeight={200}
          movable={true}
          responsive={true}
          autoCropArea={1}
          onInitialized={(instance) => {
            setCropper(instance);
          }}
        />
      </div>
      <button
        type="button"
        onClick={() => {
          getCropData(props);
        }}
        className="crop_btn"
      >
        {textmapping("Crop", props.lang)}
      </button>
      <button
        type="button"
        onClick={() => {
          props.closeCropper();
        }}
        className="cros_btn"
      >
        <img src="/assets/images/cross.png" alt="" />
      </button>
    </div>
  );
};

export default CropperComponent;
